/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { VhatsAppBaseService } from '../vhats-app-base-service';
import { hatsAppApiConfiguration } from '../hats-app-api-configuration';
import { hatsAppStrictHttpResponse } from '../hats-app-strict-http-response';

import { apiConsumerWhatsappOptinPost } from '../fn/consumer/api-consumer-whatsapp-optin-post';
import { ApiConsumerWhatsappOptinPost$Params } from '../fn/consumer/api-consumer-whatsapp-optin-post';
import { OptInResponse } from '../models/opt-in-response';


/**
 * Controller for consumer-facing WhatsApp endpoints. Provides authenticated access to WhatsApp functionality for internal users.
 */
@Injectable({ providedIn: 'root' })
export class hatsAppConsumerService extends VhatsAppBaseService {
  constructor(config: hatsAppApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiConsumerWhatsappOptinPost()` */
  static readonly ApiConsumerWhatsappOptinPostPath = '/api/consumer/whatsapp/optin';

  /**
   * Generates a one-time opt-in code for linking this user's profile to WhatsApp.
   * The app should instruct the user to send "OptIn:xxxxxxxxxxxx" to the configured WhatsApp number.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiConsumerWhatsappOptinPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiConsumerWhatsappOptinPost$Response(params?: ApiConsumerWhatsappOptinPost$Params, context?: HttpContext): Observable<hatsAppStrictHttpResponse<OptInResponse>> {
    const obs = apiConsumerWhatsappOptinPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Generates a one-time opt-in code for linking this user's profile to WhatsApp.
   * The app should instruct the user to send "OptIn:xxxxxxxxxxxx" to the configured WhatsApp number.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiConsumerWhatsappOptinPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiConsumerWhatsappOptinPost(params?: ApiConsumerWhatsappOptinPost$Params, context?: HttpContext): Observable<OptInResponse> {
    const resp = this.apiConsumerWhatsappOptinPost$Response(params, context);
    return resp.pipe(
      map((r: hatsAppStrictHttpResponse<OptInResponse>): OptInResponse => r.body)
    );
  }

}
